const translations = {
  addNewGroup: 'Add group name',
  updateGroup: 'Edit group name',
  close: 'Close',
  save: 'Save',
};

export default translations;
